export const allChildrenHaveBrandLogos = (children: MenuItem[]): boolean => {
  return children.every(
    child => child.imageUrl && child.imageUrl.includes('CRMLOGO')
  );
};
